import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { SubSink } from "subsink";

import { PageService, ConfigurationService } from "@/shared-module/services";
import { ZoneItem } from "@/shared-module/components";
import { DemoDialogComponent } from "@/core/components";
import { Submenu, Configuration } from "@/shared-module/models";
import { Userpilot } from "userpilot";

@Component({ templateUrl: "dashboard.component.html" })
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild("dialog", { static: true }) dialog: DemoDialogComponent;
  haspath = false;
  title: string;
  zones: ZoneItem[] = [];
  subMenu: Submenu;
  configuration: Configuration;
  nextDecision: Date;
  subs = new SubSink();
  demoparameters: any;
  token: string;

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.configuration = c;
        this.configurationService.redirectIfDisabled();

        if (
          this.configuration.userPilotLaunchScriptId &&
          !this.configurationService.isLaunchPopupAlreadyDisplayed()
        ) {
          Userpilot.trigger(this.configuration.userPilotLaunchScriptId);
          this.configurationService.setLaunchPopupAlreadyDisplayed(true);
        }
      },
    );

    const observable = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        const p = params;
        this.haspath = this.route.snapshot.paramMap.has("path");
        if (this.route.snapshot.paramMap.has("path")) {
          const path = this.route.snapshot.paramMap.get("path");
          return thisObject.pageService.getpath("dashboard", path);
        } else {
          return thisObject.pageService.get("dashboard");
        }
      }),
    );

    this.subs.sink = observable.subscribe((s: any) => {
      thisObject.subMenu = s.subMenu;
      thisObject.title = s.title;
      thisObject.nextDecision = s.nextDecision;
      thisObject.token = s.userPilotToken;
      thisObject.load(s.zones);
    });

    if (this.configurationService.displayDemoPopup()) {
      this.configurationService.getDemoParameters().subscribe((r) => {
        this.demoparameters = r;

        if (this.demoparameters.userPilotScriptId != null) {
          setTimeout(() => {
            Userpilot.trigger(this.demoparameters.userPilotScriptId);
          }, 3000);
          this.configurationService.setDemoPopup(false);
        } else this.dialog.open();
      });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  load(zones: any[]) {
    this.zones = [];

    if (zones) {
      zones.forEach((zoneitm) => {
        this.zones.push(
          new ZoneItem(
            zoneitm.zoneType,
            zoneitm.title,
            zoneitm.dataSource,
            zoneitm.error,
            zoneitm.width,
            false,
          ),
        );
      });
    }
  }
}
